import { render, staticRenderFns } from "./AdSpendReport.vue?vue&type=template&id=801ed3d0&scoped=true"
import script from "./AdSpendReport.vue?vue&type=script&lang=js"
export * from "./AdSpendReport.vue?vue&type=script&lang=js"
import style0 from "./AdSpendReport.vue?vue&type=style&index=0&id=801ed3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801ed3d0",
  null
  
)

export default component.exports